import * as z from "zod";

export const activateCheckoutTreeById = {
  name: "activateCheckoutTreeById" as const,
  input: z.object({ checkoutTreeId: z.string() }),
  output: z.object({}),
};
